var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShowButton)?_c('BaseButton',{staticClass:"no-print",attrs:{"small":"","color":"cyan white--text","loading":_vm.isExporting,"disabled":_vm.isExporting || !_vm.hasRecords},on:{"click":_vm.exportMurk31}},[_vm._v(" Export MURK 31 ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }